import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { FiInfo } from 'react-icons/fi'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  columnGap: '4px',
  marginTop: '-18px'
}

const SutRequiredListEeConnectionTypesDescription = () =>
  <div style={wrapperStyle}>
    <Color variant='theme-filter-icon'>
      <FiInfo
        aria-hidden
        size='16px'
      />
    </Color>
    <Paragraph>
      <strong>
        <Color variant='theme-description-text'>
          The selected SUT can only be used on its own.
        </Color>
      </strong>
    </Paragraph>
  </div>

export default SutRequiredListEeConnectionTypesDescription
